import { DataService } from './../../shared/services/data.service';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AllotmentService extends DataService {

  constructor(httpClient: HttpClient, @Inject('API_BASE_URL') private baseUrl: string, toastrService: ToastrService) {
    super(baseUrl + 'api/employee-merits', httpClient, toastrService);
  }

  getLogged() {
    return this.httpClient.get(this.baseUrl + 'api/employee-merits/logged')
      .pipe(catchError(this.handleError.bind(this)))
  }

  generateEmployeeMerit(ids: number[] = []) {
    return this.httpClient.post(this.baseUrl + 'api/employee-merits/generate', ids)
      .pipe(catchError(this.handleError.bind(this)))
  }

  processAllotment(ids: number[] = []) {
    return this.httpClient.post(this.baseUrl + 'api/employee-merits/allotment', ids)
      .pipe(catchError(this.handleError.bind(this)))
  }
  downloadPdf() {
    return this.httpClient.get(this.baseUrl + 'api/employee-merits/download-pdf', {
      responseType: 'blob' // Added responseType to handle binary data
    }).pipe(catchError(this.handleError.bind(this)));
  }           

  export(ids: number[] = [], selectedPhase) {                        
    const httpOptions = {
      responseType: 'blob' as 'json'
    };

    return this.httpClient.post(this.baseUrl + 'api/allotments/export', { ids: ids, PhaseId: selectedPhase }, httpOptions)
      .pipe(catchError(this.handleError.bind(this))) 
  }

}